module.exports = __webpack_public_path__ + "img/contact-two.cb19e438.png";